import axios from '@utils/axiosInstance'

const BASE = process.env.VUE_APP_BACKEND_PUBLIC_URL

const getDefaultState = () => {
  return {
    laborCondition: null,
    positions: [],
    timebaseChangeProcesses: [],
    shiftReductionProcesses: [],
    complementaryPactProcesses: [],
    timebaseChangeDocument: null,
    complementaryPactDocument: null,
    monthlyRates: [],
    workdayTypes: [],
    selectedHolidays: [],
    compensationDays: [],
    holidaysRates: [],
    fiscalRules: [],
    paysheetGroups: [],
    signaturePendingContractLaborCondition: null,
  }
}
export const state = getDefaultState()

export const getters = {}

export const mutations = {
  UPDATE_LABOR_CONDITION(state, laborCondition) {
    state.laborCondition = laborCondition
  },
  UPDATE_POSITIONS(state, positions) {
    state.positions = positions
  },
  UPDATE_TIMEBASE_CHANGE_PROCESSES(state, timebaseChangeProcesses) {
    state.timebaseChangeProcesses = timebaseChangeProcesses.data
  },
  UPDATE_SHIFT_REDUCTION_PROCESSES(state, shiftReductionProcesses) {
    state.shiftReductionProcesses = shiftReductionProcesses.data
  },
  UPDATE_COMPLEMENTARY_PACT_PROCESSES(state, complementaryPactProcesses) {
    state.complementaryPactProcesses = complementaryPactProcesses.data
  },
  UPDATE_TIMEBASE_CHANGE_DOCUMENT(state, timebaseChangeDocument) {
    state.timebaseChangeDocument = timebaseChangeDocument
  },
  UPDATE_COMPLEMENTARY_PACT_DOCUMENT(state, complementaryPactDocument) {
    state.complementaryPactDocument = complementaryPactDocument
  },
  RESET_LABOR_CONDITION_STATE(state) {
    Object.assign(state, getDefaultState())
  },
  UPDATE_MONTHLY_RATES(state, monthlyRates) {
    state.monthlyRates = monthlyRates
  },
  UPDATE_WORKDAY_TYPES(state, workdayTypes) {
    state.workdayTypes = workdayTypes
  },
  UPDATE_SELECTED_HOLIDAYS(state, selectedHolidays) {
    state.selectedHolidays = selectedHolidays
  },
  UPDATE_COMPENSATION_DAYS(state, compensationDays) {
    state.compensationDays = compensationDays
  },
  UPDATE_HOLIDAYS_RATES(state, holidaysRates) {
    state.holidaysRates = holidaysRates
  },
  UPDATE_FISCAL_RULES(state, fiscalRules) {
    state.fiscalRules = fiscalRules
  },
  UPDATE_PENDING_CONTRACTS_PROCESSES_LABOR_CONDITION(state, signaturePendingContractLaborCondition) {
    state.signaturePendingContractLaborCondition = signaturePendingContractLaborCondition
  },
}

export const actions = {
  // Workday types
  // GET
  async fetchWorkdayTypes(store) {
    const url = `${BASE}/mx/api/v2/workdaytypes`
    try {
      const res = await axios.get(url)
      store.commit('UPDATE_WORKDAY_TYPES', res.data)
      return res.data
    } catch (e) {
      throw Error(`API Error occurred in ${url}`)
    }
  },

  // Selected holidays
  // GET
  async fetchSelectedHolidays(store) {
    const url = `${BASE}/mx/api/v2/selectedholidays`
    try {
      const res = await axios.get(url)
      store.commit('UPDATE_SELECTED_HOLIDAYS', res.data)
      return res.data
    } catch (e) {
      throw Error(`API Error occurred in ${url}`)
    }
  },

  // Compensation days
  // GET
  async fetchCompensationdays(store) {
    const url = `${BASE}/mx/api/v2/compensationdays`
    try {
      const res = await axios.get(url)
      store.commit('UPDATE_COMPENSATION_DAYS', res.data)
      return res.data
    } catch (e) {
      throw Error(`API Error occurred in ${url}`)
    }
  },

  // Holidays rates
  // GET
  async fetchHolidaysRates(store) {
    const url = `${BASE}/mx/api/v2/holidayrates`
    try {
      const res = await axios.get(url)
      store.commit('UPDATE_HOLIDAYS_RATES', res.data)
      return res.data
    } catch (e) {
      throw Error(`API Error occurred in ${url}`)
    }
  },

  // MONTHLY RATES
  // GET
  async fetchMonthlyRates(store, positionNumber) {
    const url = `${BASE}/mx/api/v2/monthlyRates/positionNumber/${positionNumber}`
    try {
      const res = await axios.get(url)
      store.commit('UPDATE_MONTHLY_RATES', res.data)
      return res.data
    } catch (e) {
      throw Error(`API Error occurred in ${url}`)
    }
  },

  // POSITIONS
  // GET
  async fetchPositions(store, filters = {}) {
    try {
      const filtersArr = []
      Object.keys(filters).forEach((key) => {
        if (filters[key] !== null || filters[key] !== undefined) {
          filtersArr.push(key + '=' + filters[key])
        }
      })
      const queryParams = filtersArr.length > 0 ? '?' + filtersArr.join('&') : ''
      const res = await axios.get(`${BASE}/mx/api/v2/positions${queryParams}`)
      store.commit('UPDATE_POSITIONS', res.data)
    } catch (e) {
      throw Error('API Error occurred.')
    }
  },

  // FISCAL RULES
  // GET
  async fetchFiscalRules(store, filters = {}) {
    try {
      const filtersArr = []
      Object.keys(filters).forEach((key) => {
        if (filters[key] !== null || filters[key] !== undefined) {
          filtersArr.push(key + '=' + filters[key])
        }
      })
      const queryParams = filtersArr.length > 0 ? '?' + filtersArr.join('&') : ''
      const res = await axios.get(`${BASE}/mx/api/v2/fiscalRules${queryParams}`)
      store.commit('UPDATE_FISCAL_RULES', res.data.data)
    } catch (e) {
      throw Error('API Error occurred.')
    }
  },

  // TIMEBASE CHANGE PROCESSES
  // GET
  async fetchTimebaseChangeProcessesAction(store, filters = {}) {
    store.commit('UPDATE_TIMEBASE_CHANGE_PROCESSES', [])
    const filtersArr = joinFilters(filters)
    const queryParams = filtersArr.length > 0 ? '?' + filtersArr.join('&') : ''
    const url = `${BASE}/mx/api/v2/timebaseChangeProcess${queryParams}`
    try {
      const res = await axios.get(url)
      store.commit('UPDATE_TIMEBASE_CHANGE_PROCESSES', res.data)
    } catch (e) {
      throw Error(`API Error occurred in ${url}`)
    }
  },
  // TIMEBASE CHANGE PROCESSES SITE
  // GET
  async fetchSiteTimebaseChangeProcessesAction(store, personnelDivision) {
    store.commit('UPDATE_TIMEBASE_CHANGE_PROCESSES', [])
    const urlTimebase = `${BASE}/mx/api/v2/sites/${personnelDivision}/timebaseChangeProcess`
    try {
      const resTimebase = await axios.get(urlTimebase)
      store.commit('UPDATE_TIMEBASE_CHANGE_PROCESSES', resTimebase.data)
    } catch (e) {
      throw Error(`API Error occurred in ${urlTimebase}`)
    }
  },
  // TIMEBASE CHANGE
  // POST
  async startTimebaseChangeAction({ store }, payload) {
    try {
      return await axios.post(`${BASE}/mx/api/v2/laborConditionManager/timebase.startTimebaseChangeProcess`, payload)
    } catch (e) {
      throw Error(`API Error occurred at /mx/api/v2/laborConditionManager/timebase.startTimebaseChangeProcess`)
    }
  },
  // SIGN ON PAPER TIMEBASE CHANGE
  // POST
  async signOnPaperTimebaseChangeProcessAction({ store }, payload) {
    try {
      return await axios.post(`${BASE}/mx/api/v2/laborConditionManager/timebase.signOnPaperTimebaseChangeProcess`, payload)
    } catch (e) {
      throw Error(`API Error occurred at /mx/api/v2/laborConditionManager/timebase.signOnPaperTimebaseChangeProcess`)
    }
  },
  // CANCEL TIMEBASE CHANGE PROCESS
  // POST
  async cancelTimebaseChangeProcessAction({ store }, payload) {
    try {
      return await axios.post(`${BASE}/mx/api/v2/laborConditionManager/timebase.cancelTimebaseChangeProcess`, payload)
    } catch (e) {
      throw Error(`API Error occurred at /mx/api/v2/laborConditionManager/timebase.cancelTimebaseChangeProcess`)
    }
  },
}

function joinFilters(filters) {
  const filtersArr = []
  Object.keys(filters).forEach((key) => {
    if (filters[key] !== null || filters[key] !== undefined) {
      filtersArr.push(`filter[${key}]=${filters[key]}`)
    }
  })
  return filtersArr
}
